export * from './details-view.interface';
export * from './details-view.service';
export * from './details-view.mock';
export const DETAILS_VIEW_SERVICE = Symbol('DetailsViewService');
